<template>
  <div class="goods-warp" :class="{ isBatch }">
    <!-- goods:{{ goods }} -->
    <div class="goods-img">
      <img :src="goods.ossSkuMainPic" />
      <div class="overlay">
        <span v-if="!isBatch" @click.stop="handleDelete(goods)">删除</span>
        <el-checkbox
          style="margin: 10px 0 0 10px;"
          v-if="isBatch"
          v-model="goods.isSelected"
        ></el-checkbox>
      </div>
    </div>
    <ul @click="goDetail" style="cursor: pointer;">
      <li class="goods-title">{{ goods.skuTitle }}</li>
      <li style="margin-top: 10px;">
        <span class="goods-price">￥{{ goods.salePrice }}</span
        ><span class="goods-priceTitle">销售价</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "goods-item",
  data() {
    return {};
  },
  watch: {
    isBatch(newValue) {}
  },
  props: {
    isBatch: {
      default: false,
      type: Boolean
    },
    goods: {
      default() {
        return {};
      },
      type: Object
    }
  },
  methods: {
    goDetail() {
      const VUE_APP_EMI_URL = this.$addUrlPerFix(process.env.VUE_APP_EMI_URL);
      window.open(`${VUE_APP_EMI_URL}${this.goods.skuId}`);
    },
    handleDelete(goods) {
      this.$emit("delete", goods);
    }
  }
};
</script>
<style lang="scss" scoped>
.goods-warp {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  // width: 194px;
  // height: 260px;
  background: #ffffff;
  border: 1px solid #ececec;
  img {
    width: 100%;
    height: 165px;
    object-fit: cover;
    object-position: center;
    vertical-align: bottom;
  }
  ul {
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box;
    // margin-left: 15px;
    .goods-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      line-height: 18px;
      height: 36px;
      text-align: left;
      font-style: normal;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .goods-price {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #f51530;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }
    .goods-priceTitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      text-align: right;
      font-style: normal;
      margin-left: 5px;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    color: white;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.4s ease, visibility 0.4s ease;
    span {
      position: absolute;
      z-index: 1;
      top: 20px;
      right: 20px;
      cursor: pointer;
      font-size: 14px;
    }
    .checkbox-container {
      position: absolute;
      top: 20px;
      left: 20px;
    }
  }
}
.goods-warp .goods-img:hover .overlay {
  opacity: 1;
  visibility: visible;
}
.goods-warp.isBatch .overlay {
  opacity: 1;
  visibility: visible;
}
</style>
